import * as am5 from "@amcharts/amcharts5"
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import * as am5xy from "@amcharts/amcharts5/xy"
import {useEffect} from "react"
import {RootState} from "../../rootReducer"
import {LoadingPanel} from "../../shared/CommonItems"
import {useAppSelector} from "../../store"

export const VehicleTypeView = () => {
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const bookingCountVehicleType = useAppSelector(
        (state: RootState) => state.containers.dashboard.bookingCountVehicleType,
    )
    const isLoadingBookingVehicleType = useAppSelector(
        (state: RootState) => state.containers.dashboard.isLoadingBookingVehicleType,
    )
    useEffect(() => {
        if (selectedDealer && bookingCountVehicleType) {
            vehicleTypeLineChart(bookingCountVehicleType)
        }
    }, [selectedDealer, bookingCountVehicleType])

    const maybeDisposeRoot = (divId: string) => {
        am5.array.each(am5.registry.rootElements, function (root) {
            if (root && root.dom != null && root.dom.id === divId) {
                root.dispose()
            }
        })
    }
    const vehicleTypeLineChart = (data: any) => {
        maybeDisposeRoot("vehicleTypeLineChart")
        const root = am5.Root.new("vehicleTypeLineChart")
        root.setThemes([am5themes_Animated.new(root)])
        const chart: any = root.container.children.push(
            am5xy.XYChart.new(root, {
                layout: root.verticalLayout,
            }),
        )

        am5plugins_exporting.Exporting.new(root, {
            menu: am5plugins_exporting.ExportingMenu.new(root, {}),
            filePrefix: "BookingbyVehicleType",
        })

        chart
            .get("colors")
            .set("colors", [am5.color(0x01b8aa), am5.color(0x2878bd), am5.color(0x37a794), am5.color(0x70b0e0)])

        const xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "dateText",
                renderer: am5xy.AxisRendererX.new(root, {
                    cellStartLocation: 0.1,
                    cellEndLocation: 0.9,
                    minGridDistance: 10,
                }),
                tooltip: am5.Tooltip.new(root, {}),
            }),
        )

        xAxis.data.setAll(data)

        const yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                calculateTotals: true,
                extraMax: 0.1,
                renderer: am5xy.AxisRendererY.new(root, {}),
            }),
        )

        const makeVehicleTypeSeries = (name: string, fieldName: string, showTotal: boolean) => {
            const series = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name,
                    xAxis,
                    yAxis,
                    valueYField: fieldName,
                    categoryXField: "dateText",
                    stacked: true,
                    tooltip: am5.Tooltip.new(root, {
                        pointerOrientation: "horizontal",
                        labelText: "[#000] {name} {valueY} [/]",
                    }),
                }),
            )

            series.data.setAll(data)

            series.bullets.push(() => {
                return am5.Bullet.new(root, {
                    sprite: am5.Label.new(root, {
                        fontSize: 12,
                        text: "{valueY}",
                        fill: root.interfaceColors.get("alternativeBackground"),
                        centerY: am5.p50,
                        centerX: am5.p50,
                        populateText: true,
                    }),
                })
            })

            series.columns.template.onPrivate("height", (height: any, target: any) => {
                am5.array.each(target.dataItem.bullets, (bullet: any) => {
                    if (height === 0) {
                        bullet.get("sprite").hide()
                    } else {
                        bullet.get("sprite").show()
                    }
                })
            })
        }

        makeVehicleTypeSeries("HGV", "hgv", false)
        makeVehicleTypeSeries("PSV", "psv", false)
        makeVehicleTypeSeries("Trailer", "trailer", false)
        makeVehicleTypeSeries("Other", "other", false)

        chart.appear(1000, 100)
        chart.set("cursor", am5xy.XYCursor.new(root, {}))

        xAxis.set(
            "tooltip",
            am5.Tooltip.new(root, {
                themeTags: ["axis"],
            }),
        )

        yAxis.set(
            "tooltip",
            am5.Tooltip.new(root, {
                themeTags: ["axis"],
            }),
        )
        const legend = chart.children.push(
            am5.Legend.new(root, {
                centerX: am5.p50,
                x: am5.p50,
            }),
        )

        legend.data.setAll(chart.series.values)
    }
    return (
        <>
            {isLoadingBookingVehicleType && <LoadingPanel />}
            <div className="h-100" id="vehicleTypeLineChart"></div>
        </>
    )
}
